export default function DateFormatingService() {
  const formatDateTime = (value: string) => {
    return new Date(value).toLocaleDateString("de-AT", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      year: "numeric",
    });
  };

  const formatDate = (value: string) => {
    return new Date(value).toLocaleDateString("de-AT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return {
    formatDateTime,
    formatDate,
  };
}
